<template>
  <b-container fluid class="full-height">
    <b-row class="full-height">
      <b-col lg="5" style="overflow-y: auto;" class="full-height">
        <b-table
            hover
            selectable
            select-mode="single"
            responsive="sm"
            ref="leftTable"
            :items="selectedItems"
            :fields="leftField"
            @row-selected="onLeftListRowSelected"
        >
        </b-table>
      </b-col>

      <b-col class="text-center arrow-roles-height">
        <b-button
            :disabled="readOnly || (!selectedItem)"
            data-test-path="move-item"
            @click="moveItem()"
            class="button-arrow"
            variant="plm-action"
        >
          <font-awesome-icon
              class="arrow d-none d-lg-block"
              v-if="isListRightActive"
              icon="arrow-left"
          />
          <font-awesome-icon
              class="arrow d-none d-lg-block"
              v-else-if="isListLeftActive"
              icon="arrow-right"
          />
          <font-awesome-icon
              class="arrow d-block d-lg-none"
              v-if="isListRightActive"
              icon="arrow-up"
          />
          <font-awesome-icon
              class="arrow d-block d-lg-none"
              v-else-if="isListLeftActive"
              icon="arrow-down"
          />
        </b-button>
      </b-col>

      <b-col lg="5" style="overflow-y: auto;" class="full-height">
        <b-table
            style="overflow-y: auto"
            hover
            selectable
            select-mode="single"
            responsive="sm"
            ref="rightTable"
            :items="allItems"
            :fields="rightField"
            @row-selected="onRightListRowSelected"
        >
        </b-table>
      </b-col>
    </b-row>
  </b-container>

</template>


<script>
import VBox from "@/components/VBox";


export default {
  name: "MultiselectList",

  components: {VBox},

  async created() {
  },

  async mounted() {
    this.leftField = [{key: this.labelField, label: this.leftLabel, sortable: true, class: 'text-center'}];
    this.rightField = [{key: this.labelField, label: this.rightLabel, sortable: true, class: 'text-center'}];
  },

  methods: {


    moveItem() {
      if (this.isListRightActive) {
        this.moveItemFromRightToLeft();
      } else {
        this.moveItemFromLeftToRight();
      }
    },

    moveItemFromRightToLeft() {
      if (this.selectedItem) {
        let index = this.allItems.indexOf(this.selectedItem);
        if (index !== -1) {
          this.$emit("add-item", index);
        }
      }
    },

    moveItemFromLeftToRight() {
      if (this.selectedItem) {
        let index = this.selectedItems.indexOf(this.selectedItem);
        if (index !== -1) {
          this.$emit("delete-item", index);
        }
      }
    },

    onLeftListRowSelected(items) {
      this.$refs.rightTable.clearSelected();
      this.isListLeftActive = true;
      this.isListRightActive = false;
      this.getSelectedRow(items);
    },

    onRightListRowSelected(items) {
      this.$refs.leftTable.clearSelected();
      this.isListRightActive = true;
      this.isListLeftActive = false;
      this.getSelectedRow(items);
    },

    getSelectedRow(items) {
      let selectedRow = items[0];
      if (selectedRow) {
        this.selectedItem = selectedRow;
      } else {
        this.selectedItem = null;
      }
    },

    changeModel() {
      this.$emit('model-change', this.selectedItems);
    },

  },


  model: {
    prop: 'leftTable',
    event: 'model-change',
  },

  props: {
    addItem: Function,
    deleteItem: Function,

    readOnly:       {type: Boolean, default: true},
    leftTable:      {type: Array, default: []},
    leftLabel:      {type: String, default: ""},
    rightLabel:     {type: String, default: ""},
    labelField:     {type: String, default: ""},
    selectMode:     {type: String, default: "single"},

    allItems:       {type: Array, default: []},

  },

  watch: {
    selectedItems: function (newVal, oldVal) {
      this.changeModel();
    },
    leftTable: function (newVal, oldVal) {
      this.selectedItems = newVal;
    },
  },

  data: () => ({
    leftField: [],
    rightField: [],
    selectedItem: null,
    selectedItems: [],
    isListLeftActive: false,
    isListRightActive: true,
  })
}
</script>
